export function getFileSize(sizeByte: number | undefined) {
  if (typeof sizeByte == 'undefined') return '--'
  if (sizeByte < 1024) {
    return sizeByte + 'B'
  } else if (sizeByte < 1024 * 1024) {
    return (sizeByte / 1024).toFixed(2) + 'KB'
  } else if (sizeByte < 1024 * 1024 * 1024) {
    return (sizeByte / 1024 / 1024).toFixed(2) + 'MB'
  } else {
    return (sizeByte / 1024 / 1024 / 1024).toFixed(2) + 'GB'
  }
}

/**
 * @deprecated Use formatStorageGB from '@/utils/storage' instead.
 * Example: formatStorageGB(toBytes(mb, 'mb'))
 */
export function mb2GbString(mb: number) {
  return (parseFloat(`${mb}`) / 1024).toFixed(2) + ' GB'
}

/**
 * @deprecated Use formatStorageGB from '@/utils/storage' instead.
 * Example: formatStorageGB(toBytes(gb, 'gb'), { decimals: 0 })
 */
export function toGbStrig(gb: number) {
  return `${gb} GB`
}

interface ValidationResult {
  isValid: boolean
  errorMessage?: string
}

const IMAGE_FILENAME_REGEX =
  /^(([a-z0-9_.-]+)(:\d{1,5})?)?((\/[a-z0-9_.-]+)*\/)*[a-z0-9_.-]+(:[a-zA-Z0-9_.-]+)?$/
const IMAGE_URL_FORMAT_REGEX =
  /^(([a-z0-9_.-]+)(:\d{1,5})?)?((\/[a-z0-9_.-]+)*\/)*[a-z0-9_.-]+:[a-zA-Z0-9_.-]+$/

export function validateImageFileName(imageFileName: string): ValidationResult {
  if (!imageFileName) {
    return {
      isValid: false,
      errorMessage: 'Image filename is required',
    }
  }

  if (!IMAGE_FILENAME_REGEX.test(imageFileName)) {
    return {
      isValid: false,
      errorMessage:
        'Image filename must contain only lowercase letters, numbers, dots, hyphens, and underscores.',
    }
  }

  return { isValid: true }
}

export function validateImageUrlFormat(imageFileName: string): ValidationResult {
  if (!imageFileName) {
    return {
      isValid: false,
      errorMessage: 'Image filename is required',
    }
  }

  if (!IMAGE_URL_FORMAT_REGEX.test(imageFileName)) {
    return {
      isValid: false,
      errorMessage: 'Invalid image URL format.',
    }
  }

  return { isValid: true }
}

export function validateTarFileName(fileName: string): ValidationResult {
  if (!fileName) {
    return {
      isValid: false,
      errorMessage: 'Filename is required',
    }
  }

  if (!fileName.toLowerCase().endsWith('.tar')) {
    return {
      isValid: false,
      errorMessage: 'File must have a .tar extension',
    }
  }

  return { isValid: true }
}

export function validateRawFileName(fileName: string): ValidationResult {
  if (!fileName) {
    return {
      isValid: false,
      errorMessage: 'Filename is required',
    }
  }

  if (!fileName.toLowerCase().endsWith('.raw')) {
    return {
      isValid: false,
      errorMessage: 'File must have a .raw extension',
    }
  }

  return { isValid: true }
}
